import React from 'react';
import imagePreview from '../../../assets/images/imagePreview.png';

const ImagePreview = (): JSX.Element => {
  return (
    <img src={imagePreview} width="100%" height="auto" alt="preview" />
  );
};

export default ImagePreview;